import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { ChangePassword, Login } from '../models/loginModel';
import { LoggedInUserInfo } from '../models/loggedInUserModel';
import { AuthService } from '../services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-updatePassword',
  templateUrl: './updatePassword.component.html',
  styleUrls: ['./updatePassword.component.css'],
  standalone: false
})
export class UpdatePasswordFormComponent {
  login: Login = new Login('', '', true, '', '');
  changePassword: ChangePassword = new ChangePassword('', '', '');
  user?: LoggedInUserInfo;
  errorMessage: string = '';
  action: string = '';

  constructor(private loginService: LoginService, private router: Router, private authService: AuthService, private route: ActivatedRoute) {

  }


  onSubmit() {
    this.route.queryParams.subscribe((params) => {
      this.action = params['action'];
    })
    if (this.action == 'change') {
      this.changePassword.username = localStorage.getItem('UserName') ?? '';
      this.changePassword.password = this.login.password;
      this.changePassword.confirmPassword = this.login.confirmPassword;
      this.loginService.changePassword(this.changePassword).subscribe((user) => {
        alert('Password Updated, Please login with new credentials');
        this.router.navigate(['/logout']);
      },
        (error) => {
          console.log(error);
          if (error instanceof HttpErrorResponse) {
            this.errorMessage = `Error: ${error.error.message}`;
          } else {
            this.errorMessage = `Error: ${error.message}`;
          }
        });
    }
    else {
      this.login.username = this.authService.UserName$.value;
      this.login.passwordChange = true;
      this.login.session = this.authService.Session$.value;
      this.loginService.loginUser(this.login).subscribe((user) => {
        alert('Password Updated, Please login with new credentials');
        this.router.navigate(['/logout']);
      },
        (error) => {
          if (error instanceof HttpErrorResponse) {
            this.errorMessage = `Error: ${error.error.message}`;
          } else {
            this.errorMessage = `Error: ${error.message}`;
          }
        });
    }
  }
}
